var $ = jQuery;
if ($(window).width() < 992 ) {
jQuery(document).ready(function($){
     $('.homepage-collection-list').slick({
    dots: true,
    arrows: false,
		infinite: true,
		slidesToScroll: 1,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1,
                  dots: true,
                  autoplay: true,
				}
			}
		]
  });
});

}